import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";

// import { createStore, applyMiddleware } from "redux";
import { Provider } from "react-redux";
// import Reducers from "./reducers/index";
// import Thunk from "redux-thunk";
import store from "store";
// import { configureChains, createConfig, WagmiConfig } from 'wagmi';
// import { EthereumClient, w3mConnectors, w3mProvider } from '@web3modal/ethereum'

// const store = createStore(Reducers, applyMiddleware(Thunk));
ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
        {/* <WagmiConfig config={wagmiConfig}> */}
          <App />
        {/* </WagmiConfig> */}
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
